import React from 'react';
import styles from './stats.module.css';

/** Bloco com título dentro de uma seção (um gráfico, um ranking, uma lista). */
const ChartBlock = ({ title, hint, children }) => (
  <div className={styles.block}>
    <h3 className={styles.blockTitle}>
      <span>{title}</span>
      {hint && <span className={styles.blockHint}>{hint}</span>}
    </h3>
    {children}
  </div>
);

export default ChartBlock;
